import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var LogIn03 = function LogIn03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M6 17c0 .3513 0 .5269.0157.6796a3 3 0 0 0 2.2864 2.6115c.1492.0357.3234.0589.6716.1054l6.5919.8789c1.8764.2502 2.8147.3753 3.5428.0857a3 3 0 0 0 1.5084-1.3205C21 19.357 21 18.4105 21 16.5175v-9.035c0-1.8931 0-2.8396-.3832-3.5231a3 3 0 0 0-1.5084-1.3206c-.7281-.2895-1.6664-.1644-3.5428.0857l-6.592.879c-.3481.0464-.5222.0696-.6715.1053a3 3 0 0 0-2.2864 2.6115C6 6.473 6 6.6487 6 7m6 1 4 4m0 0-4 4m4-4H3"
    })
  }));
};
export default LogIn03;